export default "__VITE_ASSET__BxtP4Fav__"